<template>
  <div class="hello">
    <img id="gazou" src="@/assets/photo01.jpg" />
    <h1>
      <span class="title">コロナにまけるな</span>
      <span class="title">短編小説コンテスト</span>
    </h1>
    <div id="apeal">
      <ul id="list">
        <li>
          <span class="litem">テーマは</span>
          <span class="litem">「感染症」かつ「希望を感じられる話」</span>
        </li>
        <li>400字から応募可能</li>
        <li>メールアドレスだけで応募可能</li>
        <li>学生限定</li>
        <li>応募者全員に一言感想</li>
        <li>受賞者には図書カード進呈</li>
      </ul>
      <br />
    </div>
    <div style="line-height: 2.0em">
      <router-link v-bind:to="{ name : 'Post', params : { form:true  }}">応募フォーム</router-link>
      <br />
      <router-link to="/Award">受賞作品</router-link>
      <br />
      <router-link to="/Recent">応募作</router-link>
      <br />
      <router-link to="/Evaluate">評価システムについて</router-link>
      <br />
      <router-link to="/Youkou">応募要項</router-link>
      <br />
      <router-link to="/privacy">プライバシーポリシー</router-link>
      <br />
      <router-link to="/about">この大会について</router-link>
      <br />
      <br />
    </div>
    <button v-if="!signin" @click="signIn">サインイン</button>
    <button v-else @click="signOut">サインアウト</button>
  </div>
</template>

<script>
import firebase from "firebase/app";
//import Youkou from "@/assets/応募要項.pdf";

export default {
  name: "Root",
  props: {
    //youkou: Youkou
  },
  data() {
    return {
      signin: true
    };
  },
  created() {
    // view が作られた時にデータを取得し、
    // そのデータは既に監視されています
    this.fetchData();
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.signin = true;
        } else {
          this.signin = false;
        }
      });
    },
    signIn: function() {
      this.$router.push({ name: "Signin" });
    },
    signOut: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({
            path: this.$router.currentRoute.path,
            force: true
          });
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
}
.title {
  display: inline-block;
  font-weight: 800;
}
.litem {
  display: inline-block;
}
#gazou {
  width: 90%;
  max-width: 650px;
}
#apeal {
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  max-width: 100%;
}
#list {
  text-align: left;
  margin-right: 16px;
  word-wrap: break-word;
}
h1 {
  font-weight: normal;
}
a {
  color: #42b983;
}
</style>
